module.exports = __webpack_public_path__ + "img/kivacrm-logo.73febcea.svg";